import React from "react";
import SignInPresenter from "./SignInPresenter";
import { signInUseCase } from "../../usecases/user";
import { Button } from "../../nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";
import "./style.css";

class SignInPage extends BasePage {
  constructor() {
    super();
    this.presenter = new SignInPresenter(this, signInUseCase());
    this.state = {
      progress: false,
      username: "",
      password: "",
      usernameFocused: false,
      passwordFocused: false,
      error: null,
    };
  }

  formSubmit(e) {
    e.preventDefault();
    this.setState({ error: null });
    this.presenter.submit();
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
    this.setState({ [field]: value, error: null });
  }

  onFocus(field) {
    this.setState({ [`${field}Focused`]: true });
  }

  onBlur(field) {
    this.setState({ [`${field}Focused`]: false });
  }

  setError(errorMessage) {
    this.setState({ error: errorMessage });
  }

  isAdmin() {
    const user = this.getCurrentUser();
    return user.roles.some((role) => role.id === "Admin");
  }

  render() {
    const master = this.props.params.master === "master";
    return (
      <div className="signin-container min-vh-100 d-flex justify-content-center align-items-center">
        <div className="signin-wrapper">
          {/* Logo Section */}
          <div className="signin-logo-container">
            <img src="/logo.svg" alt="company logo" className="signin-logo" />
          </div>

          {/* Form Container */}
          <div className="signin-form-container">
            <div className="signin-header">
              <h1 className="signin-title">Welcome Back</h1>
              <p className="signin-subtitle">
                Sign in to your account to continue
              </p>
            </div>

            <form onSubmit={this.formSubmit.bind(this)} className="signin-form">
              <div className="signin-input-group">
                {/* Username Field */}
                <div
                  className={`signin-input-wrapper ${
                    this.state.usernameFocused ? "signin-input-focused" : ""
                  }`}
                >
                  <i className="bi bi-person-fill signin-input-icon"></i>
                  <InputFactory
                    required
                    type="String"
                    autoComplete="nope"
                    className="signin-input"
                    placeholder="Username or Email"
                    field="username"
                    onChange={this.onChange.bind(this)}
                    onFocus={() => this.onFocus("username")}
                    onBlur={() => this.onBlur("username")}
                  />
                </div>

                {/* Password Field */}
                <div
                  className={`signin-input-wrapper ${
                    this.state.passwordFocused ? "signin-input-focused" : ""
                  }`}
                >
                  <i className="bi bi-lock-fill signin-input-icon"></i>
                  <InputFactory
                    required
                    type="Password"
                    className="signin-input"
                    placeholder="Password"
                    field="password"
                    onChange={this.onChange.bind(this)}
                    onFocus={() => this.onFocus("password")}
                    onBlur={() => this.onBlur("password")}
                  />
                </div>
              </div>

              {/* Error Message */}
              {this.state.error && (
                <div className="signin-error-message">
                  <i className="bi bi-exclamation-circle-fill"></i>
                  <span>{this.state.error}</span>
                </div>
              )}

              {/* Submit Button */}
              <Button
                progress={this.state.progress}
                type="submit"
                className={`signin-button ${
                  this.state.progress ? "signin-button-loading" : ""
                }`}
                disabled={this.state.progress}
              >
                {this.state.progress ? (
                  <>
                    <span>Signing in...</span>
                  </>
                ) : (
                  <>
                    <span>Sign In</span>
                    <i className="bi bi-arrow-right"></i>
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignInPage);
